import { InMemoryCache } from '@apollo/client'
import User from '@utils/storage/user'

const cache = new InMemoryCache()

const user = cache.makeVar(User.get())
const isLoggingOut = cache.makeVar(false)

export { cache, user, isLoggingOut }
